import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
// import { auth } from '../../helpers/Firebase';
import axios from 'axios';

import {
  LOGIN_USER,
  REGISTER_USER,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
} from '../actions';

import {
  loginUserSuccess,
  logoutUserSuccess,
  loginUserError,
  registerUserSuccess,
  registerUserError,
  forgotPasswordSuccess,
  forgotPasswordError,
  resetPasswordSuccess,
  resetPasswordError,
} from './actions';

import { adminRoot, currentUser, apiUrl } from "../../constants/defaultValues"
import { setCurrentUser, setActiveFeatures } from '../../helpers/Utils';
import { apiGetActiveFeatures, setBillingAuthToken } from '../../services/billingApi';

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

const loginWithEmailPasswordAsync = async (username, password, cloudId) => {
  const payload = {
    cloud_id: cloudId,
    user: username,
    password: password
  };

  try {
    const resp = await axios.post(`${process.env.REACT_APP_PROVISIONING_URL}authLogin`, payload)
    return resp.data
  } catch (err) {
    return err;
  }
}

function* loginWithEmailPassword({ payload }) {

  const { username, password, cloudId } = payload.user;
  const { history } = payload;
  try {
    const loginUser = yield call(loginWithEmailPasswordAsync, username, password, cloudId);
    if (!loginUser.message) {
      localStorage.setItem('userName', username);
      localStorage.setItem('cloud_id', cloudId);
      localStorage.setItem('user_id', loginUser.id);
      localStorage.setItem('companyName', loginUser.company);
      localStorage.setItem('sub_cloud_id', loginUser.sub_cloud_id);
      localStorage.setItem('ai_company_id', loginUser.ai_company_id);
      localStorage.setItem('Token', loginUser.Token);
      localStorage.setItem('subscriber_id', loginUser.subscriber_id);

      const item = { userObject: loginUser, ...currentUser };
      const payLoad2 = {
        user_id: loginUser.id
      };
      const headers = {
        headers: {
          Token: localStorage.getItem("Token"),
        }
      }
      axios.post(`${process.env.REACT_APP_PROVISIONING_URL}subscriberAttrsDetail`, payLoad2, headers)
        .then(response => {
          localStorage.setItem('subscriberAttrs', JSON.stringify(response.data));
        })
        .catch(err => {
          console.log("No Attr Found");
        });
      
      // Fetch and store active features
      try {
        setBillingAuthToken(loginUser.Token);
        const activeFeatures = yield call(apiGetActiveFeatures, loginUser.subscriber_id);
        setActiveFeatures(activeFeatures || []);
      } catch (err) {
        console.error('Error fetching active features:', err);
        setActiveFeatures([]);
      }
      
      setCurrentUser(item);
      yield put(loginUserSuccess(item));
      window.location.href = `${adminRoot}/provisioning/dashboard`;
    } else {
      yield put(loginUserError(loginUser.message));
    }
  } catch (error) {
    yield put(loginUserError(error));
  }
}

export function* watchRegisterUser() {
  yield takeEvery(REGISTER_USER, registerWithEmailPassword);
}

const registerWithEmailPasswordAsync = async (email, password) => {
  // await auth
  //   .createUserWithEmailAndPassword(email, password)
  //   .then((user) => user)
  //   .catch((error) => error);
}


function* registerWithEmailPassword({ payload }) {
  const { email, password } = payload.user;
  const { history } = payload;
  try {
    const registerUser = yield call(
      registerWithEmailPasswordAsync,
      email,
      password
    );
    if (!registerUser.message) {
      const item = { uid: registerUser.user.uid, ...currentUser };
      setCurrentUser(item);
      yield put(registerUserSuccess(item));
      window.location.href = adminRoot;
    } else {
      yield put(registerUserError(registerUser.message));
    }
  } catch (error) {
    yield put(registerUserError(error));
  }
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout);
}

const logoutAsync = async (history) => {
  // await auth
  //   .signOut()
  //   .then((user) => user)
  //   .catch((error) => error);
  window.location.href = '/user/login';
};

function* logout({ payload }) {
  const { history } = payload;
  setCurrentUser();
  yield call(logoutAsync, history);
  yield put(logoutUserSuccess(history));
}

export function* watchForgotPassword() {
  yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

const forgotPasswordAsync = async (email) => {
  // return await auth
  //   .sendPasswordResetEmail(email)
  //   .then((user) => user)
  //   .catch((error) => error);
};

function* forgotPassword({ payload }) {
  const { email } = payload.forgotUserMail;
  try {
    const forgotPasswordStatus = yield call(forgotPasswordAsync, email);
    if (!forgotPasswordStatus) {
      yield put(forgotPasswordSuccess('success'));
    } else {
      yield put(forgotPasswordError(forgotPasswordStatus.message));
    }
  } catch (error) {
    yield put(forgotPasswordError(error));
  }
}

export function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

const resetPasswordAsync = async (resetPasswordCode, newPassword) => {
  // return await auth
  //   .confirmPasswordReset(resetPasswordCode, newPassword)
  //   .then((user) => user)
  //   .catch((error) => error);
};

function* resetPassword({ payload }) {
  const { newPassword, resetPasswordCode } = payload;
  try {
    const resetPasswordStatus = yield call(
      resetPasswordAsync,
      resetPasswordCode,
      newPassword
    );
    if (!resetPasswordStatus) {
      yield put(resetPasswordSuccess('success'));
    } else {
      yield put(resetPasswordError(resetPasswordStatus.message));
    }
  } catch (error) {
    yield put(resetPasswordError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchRegisterUser),
    fork(watchForgotPassword),
    fork(watchResetPassword),
  ]);
}
